import {connect} from 'react-redux';
import {changeCred} from '../actions/changeCreds';
import {setComment} from '../actions/changeComm';
import {addOrder, removeOrder} from '../actions/changeOrders';
import bindActionCreators from "redux/es/bindActionCreators";
import OrderForm from '../components/OrderForm';

const mapStateToProps = (state, props) => (
    {creds: state.creds, files: state.files, orders: state.orders, comment: state.comment}
);

const mapDispatchToProps = dispatch => ({
    setCred: cred => dispatch(changeCred(cred)),
    setComm: comm => dispatch(setComment(comm)),
    ...bindActionCreators({addOrder, removeOrder}, dispatch)
});

const Form = connect(mapStateToProps, mapDispatchToProps)(OrderForm);

export default Form;


// WEBPACK FOOTER //
// ./src/app/containers/Form.js